<template>
    <div class="container">
    <Nav></Nav>
     <div class="banner">
        </div>
         <!-- <div class="bread">
            <div>
                <div class="bread-mulu">
                    <img src="../assets/images/newlist-mulu.png" alt="" @click="$router.push({path:'/'})" style="cursor:pointer">
                    <span></span>
                    <p>产品展示</p>
                    <span></span>
                    <p class="br-name">项目产品</p>
                </div>
            </div>
        </div> -->
        <div class="warp" @mouseleave="moveOut">
           <div class="nav">
            <div class="cate">
                <div :class="[typeIndex==1?'navActive':'']" @mouseover="moveIn(1)">职业教育培训</div>
                <div :class="[typeIndex==2?'navActive':'']" @mouseover="moveIn(2)">职业智能考评</div>
                <div :class="[typeIndex==3?'navActive':'']" @mouseover="moveIn(3)">监管体系</div>
            </div>
        </div>
         <div class="cateSecond" v-if="seList.length>0">
                <div class="swaper-box">
                  <swiper :options="swiperOption1">
                    <swiper-slide v-for="(item,index) in seList" :key="index" >
                      <div @click="toPage(item.Id)" :class="[seIndex==item.Id?'secondActive':'']"><p>{{item.Name}}</p></div>
                    </swiper-slide>
                    <div v-show="seList.lenght>4" class="swiper-button-next"></div>
                    <div v-show="seList.lenght>4" class="swiper-button-prev"></div>
                  </swiper>
                </div>
                <!-- <div v-for="(item,index) in seList" :key="index" :class="[seIndex==item.Id?'secondActive':'']" @click="toPage(item.Id)"><p>{{item.Name}}</p></div> -->
            </div>
        </div>
        <div class="con">
            <div class="left">
               <p class="title">{{data.Name}}</p>
                <hr>
                <img class="spec" :src="data.LogoUrl" alt="">
                <p class="left-con" v-html="data.Content"></p>
            </div>
            <div class="right">
                <div v-if="data.XcxUrl">
                    <p class="about">相关应用推荐</p>
                    <img class="code" :src="data.XcxUrl" alt="">
                    <p class="wei">— 微信扫一扫 —</p>
                    <p class="use">使用小程序<span></span></p>
                </div>
                 <div v-if="data.GzhUrl">
                    <p class="about">相关应用推荐</p>
                    <img class="code" :src="data.GzhUrl" alt="">
                    <p class="wei">— 微信扫一扫 —</p>
                    <p class="use">关注公众号<span></span></p>
                </div>
                 <div v-if="data.AppUrl">
                    <p class="about">相关应用推荐</p>
                    <img class="code" :src="data.AppUrl" alt="">
                    <p class="wei">— 微信扫一扫 —</p>
                    <p class="use">使用APP<span></span></p>
                </div>
            </div>
        </div>
    <Footer></Footer>
    </div>
</template>

<script>
import Nav from '@/components/topNav.vue'
import Footer from '@/components/footer.vue'
export default {
  components: {
    Nav,
    Footer
  },
  data () {
    return {
      list: [], // 获取所有数据
      typeIndex: 1, // 行业类型
      seList: [], // 二级行业
      seIndex: '', // 二级行业Id
      jiaoList: [],
      zhiList: [],
      jianList: [],
      data: '', // 当前显示数据
      swiperOption1: {
        slidesPerView: 4,
        spaceBetween: 20,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      }
    }
  },
  mounted () {
    let that = this
    this.axios({
      methods: 'GET',
      url: '/api/ProductSys/GetProducts'
    })
      .then(result => {
        // console.log(result, 'result')
        if (result.data.success) {
          let arr = result.data.data
          that.list = arr
          arr.forEach(function (item, index) {
            if (item.SolutionType == 1) {
              if (that.jiaoList.length < 4) {
                that.jiaoList.push(item)
              }
            } else if (item.SolutionType == 2) {
              if (that.zhiList.length < 4) {
                that.zhiList.push(item)
              }
            } else if (item.SolutionType == 3) {
              if (that.jianList.length < 4) {
                that.jianList.push(item)
              }
            }
          })
          if (that.$route.query.page) {
            that.typeIndex = that.$route.query.page
            let idd = that.$route.query.page
            if (idd == 1) {
              that.typeIndex = idd
              that.seList = that.jiaoList
              that.seIndex = that.jiaoList[0].Id
            } else if (idd == 2) {
              that.typeIndex = idd
              that.seList = that.zhiList
              that.seIndex = that.zhiList[0].Id
            } else if (idd == 3) {
              that.typeIndex = idd
              that.seList = that.jianList
              that.seIndex = that.jianList[0].Id
            }
          } else {
            that.typeIndex = 1
            that.seList = that.jiaoList
            that.seIndex = that.jiaoList[0].Id
          }
          this.toPage(that.seIndex)
        }
      })
      .catch(err => {
        console.log(err)
      })
  },
  methods: {
    moveIn (index) {
      this.typeIndex = index
      if (index == 1) {
        this.seList = this.jiaoList
      } else if (index == 2) {
        this.seList = this.zhiList
      } else if (index == 3) {
        this.seList = this.jianList
      }
    },
    toPage (id) {
      // console.log(id, 'idddd')
      let that = this
      this.seIndex = id
      that.list.forEach(function (item, index) {
        if (item.Id == id) {
          that.data = item
        }
      })
      // console.log(this.data, 'data')
    },
    moveOut () {
      // console.log(this.seIndex,'seeindexs');
      // console.log(this.data, 'data')
      this.typeIndex = this.data.SolutionType
      this.moveIn(this.typeIndex)
    }
  }
}
</script>
<style scoped>
.container{
    width: 100%;
    background-color: #F7F7F7;
}
.banner{
    width: 100%;
    height: 300px;
    background: url("../assets//images/solution/insdustrySolution.png") no-repeat center;
    overflow: hidden;
}
.bread{
    width: 100%;
  height: 56px;
  background: #FBFBFB;
}
.bread div{
    width: 1200px;
    margin: 0px auto;
}
.bread .bread-mulu{
    width: 175px;
    float: left;
    line-height: 56px;
    display: flex;
    justify-content: space-between;
}
.bread .bread-mulu img{
    width:12px;
    height: 12px;
    align-self: center;
    vertical-align: 0px;
}
.bread .bread-mulu span{
    display: inline;
    width: 0px; /*  宽高设置为0，很重要，否则达不到效果 */
    height: 0px;
    border: 5px solid #727272;
    border-top-color: transparent; /*设置透明背景色*/
    border-right-color: transparent;
    border-bottom-color: transparent;
    align-self: center;
    margin-right:-15px;
}
.bread .bread-mulu .br-name{
    color: #B00000;
}
.nav{
    width: 100%;
    /* height:60px; */
    background-color: #FBFBFB;
}
.nav .cate{
    width: 1000px;
    height: 60px;
    /* background: #F2F2F2; */
    margin: 0px auto 0px;
    display: flex;
}
.nav .cate div{
    text-align: center;
    flex: 1;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #333333;
    line-height: 60px;
    cursor: pointer;
}
.navActive{
    color: #B00000;
   background-image: url('../assets/images/solution/nav-top1.png');
   background-size: 103px 8px;
   background-repeat: no-repeat;
   background-position: center 50px;
}
.cateSecond{
    width: 1200px;
    background: #F7F7F7;
    margin: 26px auto 0px;
    overflow: hidden;
}
.cateSecond div{
    /* width: 280px;
    height: 88px;
    float: left;
    cursor: pointer;
    margin-right: 20px;
    align-items: center;
    background-color: #fff;
    color: #333333; */
}
.cateSecond .swiper-slide{
  background: #fff;
 height: 88px;
}
.cateSecond .swiper-slide>div{
   height: 88px;
   width: 100%;
   display: flex;
   align-items: center;
   cursor: pointer;
   color: #333;
}
.cateSecond .swiper-slide>div p{
        width: 100%;
    margin: 0px 20px 0px 20px;
    letter-spacing: 1px;
    font-family: PingFang SC;
    font-weight: bold;
    line-height: 24px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    text-align: center;
}
/* .cateSecond .swaper-box{
  width: 100%;
  background-color: orange;
}

.cateSecond .swaper-box p{
  width: 280px;
  background-color: #fff;
} */
.secondActive{
  background-color: #B00000 !important;
  color: #fff !important;
}
.con{
    width: 1200px;
    /* height: 800px; */
    /* background-color: orange; */
    margin: 20px auto 100px;
    display: flex;
    justify-content: space-between;
}
.con .left{
    width: 894px;
    height: 100%;
    background-color: #fff;
    text-align: center;
    padding-bottom: 100px;
}
.con .right{
    width: 282px;
    height: 100%;
    /* background-color: pink; */
}
.con .left .spec{
    width: 840px;
    margin-top: 22px;
}
.con .left .title{
    font-size: 26px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #333333;
    margin-top: 30px;
}
.con .left hr{
    border:none;
    /* border-top: 1px soild red; */
    border-top:1px solid #E2E2E2 ;
    width: 800px;
    margin: 20px auto 0px;
}
.con .left .left-con{
    width: 840px;
    margin: 35px auto 0px;
    font-size: 16px;
    color: #333333;
    text-align: left;
    line-height: 30px;
}
.con .right div{
    width:282px ;
    height: 270px;
    background-color: #fff;
    text-align: center;
    overflow: hidden;
    margin-bottom: 30px;
}
.con .right div .about{
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #333333;
    margin: 16px 0px 0px 0px;
    letter-spacing: 2px;
}
.con .right div .code{
    width: 142px;
    margin: 10px 0px 0px;
}
.con .right div .wei{
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #333333;
    letter-spacing: 1px;
}
.con .right div .use{
    position: relative;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #333333;
    letter-spacing: 1px;
    margin: 5px 0px 0px;
}
.con .right div .use span{
    position: absolute;
    display: inline-block;
    top: 10px;
    left: 94px;
    width: 82px;
    height: 9px;
    background: #B00000;
    opacity: 0.1;
}
</style>



// WEBPACK FOOTER //
// src/views/industrySolution.vue